import {Authorities} from "./interface";
import UserRole from "../app/enums/UserRole";

export const defaultAuthorities:Authorities={
    accessPermissions:[],
    roles:[UserRole.InstanceWithValue(0)]
}


